import React, { useState } from "react";
import { useFormFields } from "../libs/hooksLib";
import "./Login.css";
import { Auth } from "aws-amplify";
import Button from "@material-ui/core/Button";

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }
}));


export default function Login(props) {

   // Snackbar
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [requiresNewPassword, setRequiresNewPassword] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);
  const initialValues = {
    username: "",
    password: "",
    newPassword: "",
    confirmPassword: ""
  }
  const [fields, setValues, handleFieldChange] = useFormFields(initialValues);

  function validateForm() {
    return fields.username.length > 0 && fields.password.length > 0;
  }

  function validateNewPasswordForm() {
    return (
      fields.newPassword.length > 0 && 
      fields.confirmPassword.length > 0 && 
      fields.newPassword === fields.confirmPassword
    );
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true)

    try {
      const user = await Auth.signIn(fields.username, fields.password);
      console.log('Auth response:', user);
      
      // Check if user needs to change password
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setCognitoUser(user);
        setRequiresNewPassword(true);
        enqueueSnackbar('Du skal ændre dit password', { variant: 'info' });
      } else {
        // Successful authentication (no challenge or challenge completed)
        props.userHasAuthenticated(true);
      }
    } catch (error) {
      console.log('Auth error:', error);
      enqueueSnackbar('Kunne ikke logge ind: ' + error.message, { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }

  async function handleNewPasswordSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    try {
      // Get required attributes from the challenge parameters
      const requiredAttributes = cognitoUser.challengeParam?.requiredAttributes || [];
      const userAttributes = {};
      
      // If there are required attributes, they would need to be collected
      // For now, we pass empty object or existing attributes
      const result = await Auth.completeNewPassword(
        cognitoUser,
        fields.newPassword,
        requiredAttributes.length > 0 ? userAttributes : undefined
      );
      
      console.log('Password change result:', result);
      enqueueSnackbar('Password ændret succesfuldt', { variant: 'success' });
      props.userHasAuthenticated(true);
    } catch (error) {
      console.log('Password change error:', error);
      enqueueSnackbar('Kunne ikke ændre password: ' + error.message, { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }


  // TODO: Handle confirmation code, confirm phone, forgot password etc.

  return (

    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} sm={8} md={6} lg={4}>
        <Paper
          raised
          style={{ padding: "2rem" }}
        >
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img 
            src="/logo.svg" 
            alt="Logo" 
            style={{ maxWidth: "200px", width: "100%" }}
          />
        </div >
        <h6 style={{ textAlign: "center", marginBottom: "2rem" }}>
          LER Assistenten
        </h6>
        <p style={{ textAlign: "center", marginBottom: "1rem", fontSize: "0.8rem" }}>
          {requiresNewPassword 
            ? "Du skal ændre dit password før du kan fortsætte."
            : "Log ind med dit brugernavn og password. Har du glemt dit password, så kontakt support."
          }
        </p>
          <form className={classes.root} autoComplete="on" onSubmit={requiresNewPassword ? handleNewPasswordSubmit : handleSubmit}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {!requiresNewPassword ? (
                <>
                  <TextField
                    id="username"
                    label="Brugernavn"
                    style={{ margin: "1rem", width: "100%", maxWidth: "300px" }}
                    value={fields.username}
                    onChange={handleFieldChange}
                  />
                  <TextField
                    id="password"
                    style={{ margin: "1rem", width: "100%", maxWidth: "300px" }}
                    label="Password"
                    type="password"
                    value={fields.password}
                    onChange={handleFieldChange}
                  />
                
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={!validateForm() || isLoading}
                  >
                    Log ind
                  </Button>
                </>
              ) : (
                <>
                  <TextField
                    id="newPassword"
                    style={{ margin: "1rem", width: "100%", maxWidth: "300px" }}
                    label="Nyt password"
                    type="password"
                    value={fields.newPassword}
                    onChange={handleFieldChange}
                  />
                  <TextField
                    id="confirmPassword"
                    style={{ margin: "1rem", width: "100%", maxWidth: "300px" }}
                    label="Bekræft password"
                    type="password"
                    value={fields.confirmPassword}
                    onChange={handleFieldChange}
                    error={fields.confirmPassword.length > 0 && fields.newPassword !== fields.confirmPassword}
                    helperText={
                      fields.confirmPassword.length > 0 && fields.newPassword !== fields.confirmPassword
                        ? "Passwords matcher ikke"
                        : ""
                    }
                  />
                
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={!validateNewPasswordForm() || isLoading}
                  >
                    Skift password
                  </Button>
                </>
              )}
            </div>
          </form>
        </Paper>
      </Grid>   
    </Grid> 
  );
}
